import Vue from "vue";
import api from "@/api";

export default {
	actions: {
		async GetStaffList() {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetStaffList,
			});
			return response;
		},
		async GetStaff(_, entryId) {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetStaff + entryId,
			});
			return response.data;
		},
		async CreateStaff(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.CreateStaff,
				data: entry,
			});

			return response.data;
		},
		async UpdateStaff(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.UpdateStaff,
				data: entry,
			});
			return response.data;
		},
		async DeleteStaff(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.DeleteStaff,
				data: entry,
			});
			return response.data;
		},
	},
};
